import { createSlice } from '@reduxjs/toolkit';
import { getColorCodeInitials } from '../Helpers/Utility';
import { clearState } from './clearSlice';

const initialState = {
    users: {},
};

const userInfoSlice = createSlice({
    name: 'userInfoData',
    initialState,
    reducers: {
        setUserInfoArr(state, action) {
            const users = action.payload;
            users.forEach(user => {
                const existingUser = state.users[user?.userId] || {};
                const nickName = user?.name || user?.nickName || existingUser.nickName || '';
                state.users[user?.userId] = {
                    ...existingUser,
                    ...user,
                    nickName,
                    colorCode: getColorCodeInitials(nickName || user?.userId),
                };
            });
        },

        setUserInfoMap(state, action) {
            const usersMap = action.payload;

            Object.entries(usersMap).forEach(([userId, userData]) => {
                const existingUser = state.users[userId] || {};
                const name = userData.name || userData.nickName || existingUser.nickName || '';
                const image = userData.profileImage || userData.image || existingUser.image || '';
                const nickName = name || existingUser.nickName || '';

                state.users[userId] = {
                    ...existingUser,
                    ...userData,
                    userId,
                    name,
                    image,
                    nickName,
                    colorCode: getColorCodeInitials(nickName || userId),
                };
            });
        },
        deletedUserInfo(state, action) {
            const { userId } = action.payload;
            const existingUser = state.users[userId];
            if (!existingUser) return;
            state.users[userId] = {
                ...existingUser,
                isDeletedUser: 1,
            };
        },
        resetUserInfoData(state) {
            state.users = initialState.users;
        },
    },
    extraReducers: builder => {
        builder.addCase(clearState, () => initialState);
    },
});

export const { setUserInfoArr, resetUserInfoData, setUserInfoMap, deletedUserInfo } = userInfoSlice.actions;
export default userInfoSlice.reducer;
